export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// /app/src/app/containers/index.ts